var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "BField",
    { attrs: { label: "Nombre del cliente", "label-for": "customer-name" } },
    [
      _c("BAutocomplete", {
        ref: "input",
        attrs: {
          id: "customer-name",
          name: "customer-name",
          placeholder: "Alonso Navarro",
          field: "name",
          type: "name",
          icon: "account",
          value: _vm.value,
          data: _vm.customers,
          loading: _vm.loading,
          required: _vm.required,
          disabled: _vm.disabled,
          "open-on-focus": ""
        },
        on: {
          typing: _vm.getCustomers,
          input: _vm.onInput,
          select: _vm.onSelect
        },
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function(props) {
              return [
                _c("div", { staticClass: "columns is-multiline" }, [
                  _c("div", { staticClass: "column is-2" }, [
                    _vm._v("\n          email:\n        ")
                  ]),
                  _c("div", { staticClass: "column is-10" }, [
                    _vm._v(
                      "\n          " + _vm._s(props.option.email) + "\n        "
                    )
                  ]),
                  _c("div", { staticClass: "column is-2" }, [
                    _vm._v("\n          name\n        ")
                  ]),
                  _c("div", { staticClass: "column is-10" }, [
                    _vm._v(
                      "\n          " + _vm._s(props.option.name) + "\n        "
                    )
                  ]),
                  _c("div", { staticClass: "column is-2" }, [
                    _vm._v("\n          RFC:\n        ")
                  ]),
                  _c("div", { staticClass: "column is-10" }, [
                    _vm._v(
                      "\n          " + _vm._s(props.option.rfc) + "\n        "
                    )
                  ])
                ])
              ]
            }
          }
        ])
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }